export default function noop() {
  return () => {};
}